import { useStableEvent } from './useStableEvent/useStableEvent';
export const useBeforeMatch = ({ onMatch, contentRef, }) => {
    // @ts-expect-error -- event is too new
    useStableEvent('beforematch', contentRef, onMatch);
};
